// extracted by mini-css-extract-plugin
export default {"customScrollbar":"customScrollbar_customScrollbar__qYUYg","tts":"customScrollbar_tts__PWy8U","ttsModalVoicesWrapper":"customScrollbar_ttsModalVoicesWrapper__RJubR"};